import { styled } from 'styled-components'

import {
  FormattedMessage,
  InteractiveIcon,
} from '@b-stock/fe-core/bstock-react'

const TooltipP = styled.p`
  &:not(:first-child) {
    margin-top: 1rem;
  }
`

export const ListViewTooltip = () => (
  <InteractiveIcon
    size="medium"
    variant="Info"
    tooltipProps={{
      placement: 'bottom-start',
      hoverable: true,
    }}
  >
    <FormattedMessage
      id="Listings.ListView.help.tooltip"
      values={{
        p: (chunks: React.ReactNode) => <TooltipP>{chunks}</TooltipP>,
      }}
    />
  </InteractiveIcon>
)
